import { MEMBER_MEMBERSHIP_LOADING, MEMBER_MEMBERSHIP_SUCCESS, MEMBER_MEMBERSHIP_ERROR } from "../actions/actionMemberMemberships";
import { apiMemberMemberships } from 'api';
import { put, takeEvery } from 'redux-saga/effects';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get member memberships, response status: " + response.status + "\"}]}")
    }
}

function* fetchMemberMemberships(action) {
    try {
        const data = yield fetchAsync(apiMemberMemberships, action.customerId)
        yield put({ type: MEMBER_MEMBERSHIP_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: MEMBER_MEMBERSHIP_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaMemberMemberships = [
    takeEvery(MEMBER_MEMBERSHIP_LOADING, fetchMemberMemberships)
];
